// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 3H1V5.82911L11.9995 11.3798L23 5.82864V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 8.06887L11.9995 13.62L1 8.06934V21L23 21V8.06887Z"}}]};

const MailFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mail-filled',
    ref,
    icon: element,
  },
));

MailFilledIcon.displayName = 'MailFilledIcon';

export default MailFilledIcon;
